import Autocomplete from "@mui/material/Autocomplete";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type RequiredFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const RequiredField = (props: RequiredFieldProps) => {
  const value = props.value === true ? true : false;

  return (
    <Autocomplete
      id="required"
      size="small"
      onChange={(event, newValue) => {
        props.onChange(newValue);
      }}
      value={value}
      options={[true, false]}
      autoHighlight
      getOptionLabel={(option: boolean) => (option ? "True" : "False")}
      fullWidth
      disableClearable
      renderInput={(params) => (
        <EditorVisualTextField
          {...params}
          name={props.name}
          fullWidth
          label="Required"
        />
      )}
    />
  );
};

export default RequiredField;
